import StudioResponseAPI from 'dashboard/api/studio/response';
import { createStore } from '../captain/storeFactory';

export default createStore({
  name: 'StudioResponse',
  API: StudioResponseAPI,
});
